import detectiveTullyThumb from '../assets/game-detective-tully-thumb.jpg';
import colorWithMeThumb from '../assets/game-color-with-me-thumb.jpg';

/** Static bundle under public/games/detective-tully (sync via scripts/sync-games.bat). */

export const GAME_STATIC_BASE = '/games/detective-tully';

/** Fallback when embed-manifest.json is missing (hashes change after each game build). */
const GAME_BUNDLE_FALLBACK = {
  js: `${GAME_STATIC_BASE}/assets/index-CY4qpWWN.js`,
  css: `${GAME_STATIC_BASE}/assets/index-yBoaZzrH.css`,
};

let cachedBundle = null;

/** Resolve hashed JS/CSS paths from embed-manifest.json written by the game verify step. */
export async function resolveGameBundle() {
  if (cachedBundle) return cachedBundle;
  try {
    const res = await fetch(`${GAME_STATIC_BASE}/embed-manifest.json`, {
      cache: 'no-cache',
    });
    if (res.ok) {
      const manifest = await res.json();
      cachedBundle = {
        js: `${GAME_STATIC_BASE}/${String(manifest.js).replace(/^\.\//, '')}`,
        css: `${GAME_STATIC_BASE}/${String(manifest.css).replace(/^\.\//, '')}`,
      };
      return cachedBundle;
    }
  } catch {
    /* dev / stale public copy */
  }
  cachedBundle = { ...GAME_BUNDLE_FALLBACK };
  return cachedBundle;
}

/** `detective` opens Detective Tully; empty string starts Color With Me studio. */
export function getGameStartMode(gameId) {
  if (gameId === 'detective-tully') return 'detective';
  return '';
}

export const GAMES = [
  {
    id: 'detective-tully',
    title: 'Detective Tully',
    kicker: 'Look closely. Stay curious.',
    description:
      'Hidden-object mysteries across Happy Tree Valley with Detective Tully. No timer — just discovery and mango stars.',
    standaloneSrc: `${GAME_STATIC_BASE}/index.html?game=detective`,
    thumbSrc: detectiveTullyThumb,
    thumbAlt:
      'Detective Tully promotional art — Tully with magnifying glass in Happy Tree Valley',
    playBtnVariant: 'teal',
  },
  {
    id: 'color-with-me',
    title: 'Color With Me',
    kicker: "Libby's little art studio",
    description:
      'Pick a friend, choose colors, and fill beautiful scenes. Save art to your gallery and earn mango stars along the way.',
    standaloneSrc: `${GAME_STATIC_BASE}/index.html`,
    thumbSrc: colorWithMeThumb,
    thumbAlt:
      'Color With Me promotional art — Libby and friends ready to color in the art studio',
    playBtnVariant: 'warm',
  },
];

export function getGameById(id) {
  return GAMES.find(g => g.id === id) || null;
}
